var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
        },
      },
      _vm.$listeners
    ),
    [
      _c(
        "g",
        {
          staticClass:
            "sentence-24x24_svg__sentence-24x24_svg__ic-sentence-2-paper-24",
          attrs: { fill: "none", "fill-rule": "evenodd" },
        },
        [
          _c("path", {
            staticClass:
              "sentence-24x24_svg__sentence-24x24_svg__ic-sentence-2-paper-24__bg",
            attrs: { d: "M0 0h24v24H0z" },
          }),
          _c(
            "g",
            {
              staticClass:
                "sentence-24x24_svg__sentence-24x24_svg__ic-sentence-2-paper-24__icon",
              attrs: {
                stroke: "#2C3143",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                transform: "translate(3 6)",
              },
            },
            [
              _c("rect", {
                staticClass:
                  "sentence-24x24_svg__sentence-24x24_svg__ic-sentence-2-paper-24__icon__rectangle",
                attrs: { width: "18", height: "12", rx: "2" },
              }),
              _c("path", {
                staticClass:
                  "sentence-24x24_svg__sentence-24x24_svg__ic-sentence-2-paper-24__icon__line-6",
                attrs: { "stroke-linecap": "round", d: "M4 4h4M4 8h10" },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }